// Quadros desbloqueados nesta aba.
//
// sessionStorage, nao localStorage: o desbloqueio tem que morrer quando a aba
// fecha. localStorage sobreviveria ao fechamento do navegador e valeria para
// todas as abas, o que nao e o que "pede senha para abrir" significa.
//
// A MARCA E UMA TRINCA: quadro + usuario + geracao da senha
// (`protection_version`, vindo do servidor). As tres partes existem porque
// faltar qualquer uma abre um buraco real, ja visto em teste:
//
//   quadro   obvio: desbloquear um quadro nao desbloqueia outro.
//   usuario  sem ele, sair da conta e entrar com outra na MESMA aba herdava o
//            desbloqueio — o segundo usuario abria o quadro protegido sem
//            digitar nada.
//   geracao  sem ela, trocar a senha so re-trancava a aba que trocou: outra
//            aba (do mesmo usuario ou de outro) seguia com o quadro aberto,
//            porque nada no que estava guardado dizia QUAL senha havia sido
//            conferida. Com a geracao, a senha nova chega pelo polling e a
//            marca antiga simplesmente deixa de casar, em toda aba.
//
// O que fica guardado e so a trinca — nunca a senha digitada, nem nada
// derivado dela. A conferencia e sempre do servidor (POST /boards/:id/unlock);
// isto aqui so lembra que ela ja foi feita nesta aba, para nao pedir a senha
// de novo a cada navegacao entre quadros.
//
// Todo acesso em try/catch: sessionStorage estoura em aba privada com dado de
// site bloqueado, e a falha certa aqui e "pede a senha de novo", nunca uma tela
// branca.

const KEY = 'seasymon:unlockedBoards';

function read() {
  try {
    const raw = sessionStorage.getItem(KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed.filter((m) => typeof m === 'string') : [];
  } catch {
    return [];
  }
}

function write(marks) {
  try {
    sessionStorage.setItem(KEY, JSON.stringify(marks));
  } catch {
    // Sem sessionStorage o desbloqueio vale so enquanto a BoardView estiver
    // montada: o estado local dela ja libera o conteudo nesta navegacao.
  }
}

/**
 * Marca de desbloqueio. null quando falta qualquer parte da trinca — e o que
 * faz "geracao desconhecida" (quadro protegido cuja versao ainda nao chegou)
 * contar como trancado, em vez de liberado por omissao.
 */
function mark(boardId, userId, version) {
  const b = Number(boardId);
  const u = Number(userId);
  if (!Number.isInteger(b) || !Number.isInteger(u)) return null;
  if (typeof version !== 'string' || version === '') return null;
  return `${b}:${u}:${version}`;
}

export function isBoardUnlocked(boardId, userId, version) {
  const m = mark(boardId, userId, version);
  if (!m) return false;
  return read().includes(m);
}

export function markBoardUnlocked(boardId, userId, version) {
  const m = mark(boardId, userId, version);
  if (!m) return;
  const marks = read();
  if (marks.includes(m)) return;
  // Uma marca por quadro+usuario: a nova substitui a da geracao anterior, em
  // vez de a lista crescer a cada troca de senha.
  const prefix = `${Number(boardId)}:${Number(userId)}:`;
  write([...marks.filter((x) => !x.startsWith(prefix)), m]);
}

/**
 * Esquece todos os desbloqueios desta aba. Chamado no logout: a sessao acabou,
 * e o que foi desbloqueado nela nao segue valendo. A trinca por usuario ja
 * impediria o proximo usuario de herdar o desbloqueio; isto evita deixar marca
 * de sessao encerrada parada no storage.
 */
export function clearBoardUnlocks() {
  try {
    sessionStorage.removeItem(KEY);
  } catch {
    // Nada a limpar se o storage nao esta acessivel.
  }
}
